import React from 'react';
import Modal from './Modal';
import styled from 'styled-components';
import { AppColors } from '../styles/colors';

const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

const CancelButton = styled.button`
  flex: 1;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  background-color: ${AppColors.btnC};
  color: ${AppColors.onBtnC};
  
  &:hover {
    background-color: #e0e0e0;
  }
`;

const ConfirmButton = styled.button`
  flex: 1;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  background-color: ${AppColors.btnCEmphasis};
  color: ${AppColors.onBtnCEmphasis};
  
  &:hover {
    background-color: #262626;
    color: #FFFFFF;
  }
`;

interface LogoutConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  language?: 'ko' | 'en';
}

const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  language = 'ko'
}) => {
  const texts = {
    ko: {
      title: '로그아웃',
      message: '정말 로그아웃 하시겠습니까?',
      cancel: '취소',
      confirm: '로그아웃'
    },
    en: {
      title: 'Logout',
      message: 'Are you sure you want to logout?',
      cancel: 'Cancel',
      confirm: 'Logout'
    }
  };

  const t = texts[language];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={t.title}
      bgColor="white"
      body={t.message}
      footer={
        <ButtonContainer>
          <CancelButton onClick={onClose}>
            {t.cancel}
          </CancelButton>
          <ConfirmButton onClick={onConfirm}>
            {t.confirm}
          </ConfirmButton>
        </ButtonContainer>
      }
    />
  );
};

export default LogoutConfirmModal;
